// extracted by mini-css-extract-plugin
module.exports = {"toolbar_price":"toolbar_price-2zFY1","actions":"actions-3yTt-"};